export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_06.12006a25.jpg";